<template>
	<div>
		<nav
			class="grid grid-flow-col auto-cols-auto md:justify-evenly w-full gap-4 px-6 border-y-2 border-border-tertiary
				whitespace-nowrap overflow-x-auto shadow-sm border border-border-tertiary rounded-lg bg-background-primary mb-2"
			role="tablist"
		>
			<UiTabToggle
				v-for="(item, index) in tabs"
				:key="index"
				:aria-controls="item"
				:active="activeTab === item"
				role="tab"
				@click="handleSelectTab(item)"
			>
				{{ item }}
			</UiTabToggle>
		</nav>
		<div class="bg-background-secondary p-6 lg:p-10 lg:rounded-lg">
			<NuxtPicture
				v-if="activeTab === tabs[0]"
				format="webp"
				src="/images/receipt.png"
				:img-attrs="{class:'w-full'}"
				sizes="sm:100vw inf:304px"
				loading="lazy"
				width="304"
			/>
			<NuxtPicture
				v-else-if="activeTab === tabs[1]"
				format="webp"
				src="/images/receipt-short.png"
				:img-attrs="{class:'w-full'}"
				sizes="lg:100vw inf:304px"
				loading="lazy"
				width="304"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
	import slugify from 'slugify';
	import {useGtm} from '@gtm-support/vue-gtm';

	const gtm = useGtm();

	const tabs = ref(['Celá účtenka', 'Zkrácená účtenka']);
	const activeTab = ref(tabs.value[0]);

	function handleSelectTab(tab: string) {
		activeTab.value = tab;
		gtm?.push({
			event: 'click',
			type: 'tab',
			text: tab,
			target: slugify(tab, {lower: true}),
			page_type: 'competition',
			content_group: 'competition_onair',
		});
	}
</script>
